import {getData, postData} from './redux_data';
import {
    GET_TIPOS_MAQUINA,
    MODIFY_TIPO_MAQUINA,
    ADD_TIPO_MAQUINA,
    DELETE_TIPO_MAQUINA,
    UPDATE_TIPOS_MAQUINA,
} from '../constants/action_types';

export function getTiposMaquina() {
    return getData('cvtipomaquinas', GET_TIPOS_MAQUINA);
}

export function modifyTipoMaquina(tipoMaquina) {
    return (dispatch, getState) => {
        dispatch({ type: MODIFY_TIPO_MAQUINA, payload: tipoMaquina });
    }
}

export function addTipoMaquina(tipoMaquina) {
    return (dispatch, getState) => {
        dispatch({ type: ADD_TIPO_MAQUINA, payload: tipoMaquina });
    }
}

export function removeTipoMaquina(tipoMaquina) {
    return (dispatch, getState) => {
        dispatch({ type: DELETE_TIPO_MAQUINA, payload: tipoMaquina });
    }
}

export function updateTiposMaquinaDB (tipoMaquina) {
    // return (dispatch, getState) => {
    //     dispatch({ type: UPDATE_TIPOS_MAQUINA, payload: tipoMaquina })
    //     let token = getState().oidc.user ? getState().oidc.user.access_token : "";
    //     axios.post(config.API_URI() + 'cvtipomaquinas/maquinas', tipoMaquina,
    //         {
    //             headers: {
    //                 Authorization: "Bearer " + token
    //             }
    //         }
    //     ).then((response) => {
    //         dispatch({ type: UPDATE_TIPOS_MAQUINA + "_SUCCESS", payload: response })
    //         dispatch({
    //             type: OPEN_DIALOG,
    //             modalType: 'SimpleMessage',
    //             modalProps: { message: 'Cambios guardados!' },
    //             dialogid: 'success_update_tipo_maquina'
    //             });
    //     }).catch((error) => {
    //         dispatch({
    //             type: OPEN_DIALOG,
    //             modalType: 'SimpleMessage',
    //             modalProps: { message: error.response.data.message, exception: error.response.data.ex },
    //             dialogid: 'error_update_tipo_maquina'
    //             });
    //     });
    // }

    return postData('cvtipomaquinas/maquinas',UPDATE_TIPOS_MAQUINA, tipoMaquina, 'Tipos de máquina actualizados', undefined );
}

